import { catalogEntityCreatePermission } from '@backstage/plugin-catalog-common/alpha';
import { usePermission } from '@backstage/plugin-permission-react';
import Button from '@material-ui/core/Button';
import IconButton from '@material-ui/core/IconButton';
import { Theme } from '@material-ui/core/styles';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import AddCircleOutline from '@material-ui/icons/AddCircleOutline';
import { Link as RouterLink } from 'react-router-dom';

export type RegisterExistingButtonProps = {
  title: string;
  to?: string;
};

export const RegisterExistingButton = (props: RegisterExistingButtonProps) => {
  const { title, to } = props;
  const { allowed } = usePermission({
    permission: catalogEntityCreatePermission,
  });
  const isXSScreen = useMediaQuery<Theme>(theme =>
    theme.breakpoints.down('xs'),
  );

  if (!to || !allowed) {
    return null;
  }

  return isXSScreen ? (
    <IconButton
      component={RouterLink}
      color="primary"
      title={title}
      size="small"
      to={to}
    >
      <AddCircleOutline />
    </IconButton>
  ) : (
    <Button component={RouterLink} variant="outlined" color="primary" to={to}>
      {title}
    </Button>
  );
};
